/* eslint-disable */
// WARNING: this file is generated by a script, don't change it manually!
export const baseSpace = 4;
export const Spacing1 = '2px';
export const Spacing2 = '4px';
export const Spacing3 = '8px';
export const Spacing4 = '12px';
export const Spacing5 = '16px';
export const Spacing6 = '24px';
export const Spacing7 = '32px';
export const Spacing8 = '40px';
export const Spacing9 = '48px';
export const Spacing10 = '64px';
export const Spacing11 = '96px';
export const Spacing12 = '120px';